<template>
  <div class="body">
    <img :src="priceImgUrl" alt="" style="width: 100%; ">

    <div class="t-c">
      <!-- <div class="t-t">充值活动三选一</div> -->
      <div class="t-f">
        <div class="t-v" :class="[inx === '3' ? 't-active' : '']" @click="inx = '3'">
          <div class="mark">普通会员</div>
          <!-- <div class="con1">充{{ threeData.buyPriceThree }}得</div>
          <div class="con2">{{ threeData.totalPriceThree }}<span class="yuan">元</span></div> -->
          <div class="con2">¥{{ threeData.buyPriceThree }}</div>
        </div>

        <div class="t-v" :class="[inx === '2' ? 't-active' : '']" @click="inx = '2'">
          <div class="mark">超级会员</div>
          <!-- <div class="con1">充{{ threeData.buyPriceTwo }}得</div>
          <div class="con2">{{ threeData.totalPriceTwo }}<span class="yuan">元</span></div> -->
          <div class="con2">¥{{ threeData.buyPriceTwo }}</div>
        </div>

        <div class="t-v" :class="[inx === '1' ? 't-active' : '']" @click="inx = '1'">
          <div class="mark">至尊会员</div>
          <!-- <div class="con1">充{{ threeData.buyPriceOne }}得</div>
          <div class="con2">{{ threeData.totalPriceOne }}<span class="yuan">元</span></div> -->
          <div class="con2">¥{{ threeData.buyPriceOne }}</div>
        </div>
        
       
      </div>
      <div class="tips_box" v-if="inx === '3'">
        <h3>开通普通会员</h3>
        <p>{{ threeData.threeRemark }}</p>
      </div>
      <div class="tips_box" v-if="inx === '2'">
        <h3>开通超级会员</h3>
        <p>{{ threeData.twoRemark }}</p>
      </div>
      <div class="tips_box" v-if="inx === '1'">
        <h3>开通至尊会员</h3>
        <p>{{ threeData.oneRemark }}</p>
      </div>
    </div>


    <div class="footer-btn">
      <div class="btn" v-if="inx === '3'" @click="toBuyPrice(threeData.buyPriceThree)">
        立即开通永久普通会员</div>
      <div class="btn" v-if="inx === '2'" @click="toBuyPrice(threeData.buyPriceTwo)">
        立即开通永久超级会员</div>
      <div class="btn" v-if="inx === '1'" @click="toBuyPrice(threeData.buyPriceOne)">
        立即开通永久至尊会员</div>
    </div>









    <div v-html="payUrl"></div>
    <div class="shareit" v-if="is_WeChat">
      <img class="arrow" src="@/assets/img/arrowhead.png" />
      <div class="follow">支付宝支付请使用游览器进行支付,<br />请在菜单中选择游览器打开<br />如已完成支付，退出重新登录查询即可</div>
    </div>

    <div class="customer" @click="cust">
      <img src="@/assets/img/231.png" alt="">
      <!-- <div>联系客服</div> -->
    </div>

  </div>
</template>
<script>
import { Dialog, Toast } from "vant";
import areaListData from "@/utils/Area.js";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      showKefu: true,
      city: '',
      is_WeChat: false,
      payUrl: '',

      cancelSize: 0,
      leshuaPay: localStorage.getItem("leshuaPay"),
      payCode: localStorage.getItem("payCode"),
      priceImgUrl: '', //用这个图片地址  图片地址前面要加上 http://nwx.simyuxi.top:8888/
      input: this.$store.state.recordLoginText,
      isDialogShow: false,
      //设置密码
      password: "",
      confirmPassword: "",
      alreadySetUp: false,
      showPasswordPanel: false,
      showPower: false,
      passwordKeyboard: false,
      confirmPasswordKeyboard: false,
      passwordPanelTop: 50,
      kefuUrl: localStorage.getItem("kefuUrl"),

      //当前余额套餐
      currentItem: 0,
      price: 0,
      giftBalance: 0,
      inx: '1',
      //自定义金额
      popup: false,
      salePrice: 0,

      //自定义键盘
      showKeyboard: false,
      definedPrice: "",

      type: "",
      indexActive: "",
      addressVisible: false,
      areaList: areaListData, //选择地址列表
      isWan: '1', // 是否展示回退弹窗   0不展示 1展示
      isIp: '1', //  是否展示手机号与归属地  0不展示 1展示
      ipAddr: '', // IP 默认归属地  北京市-北京市
      phoneNum: localStorage.getItem("virtualNo"), //手机号
      basePkgGroup: localStorage.getItem("baseGroupId"),//获取套餐数据用的
      price: '',
      threeData: {
        buyPriceOne: '', // 充值金额
        totalPriceOne: '',//赠送金额
        oneRemark: '',//备注

        buyPriceTwo: '',
        totalPriceTwo: '',
        twoRemark: '',

        buyPriceThree: '',
        totalPriceThree: '',
        threeRemark: '',

        imgUrl: '' // 图片地址前面要加上 http://nwx.simyuxi.top:8888/
      },
    };
  },
  created() {
    wxRequest("sim/select/price/infos", { iccid: localStorage.getItem("iccid"), basePkgGroup: this.basePkgGroup }, "post").then((res) => {
      if (res.data.code == 200) {
        this.ipAddr = res.data.data.ipAddr;
        this.city = res.data.data.city;
        var result = res.data.data;
        this.priceImgUrl = "http://10086.sm.iot000.cn:8888/" + res.data.data.imgUrl;
        for (var key in this.threeData) {
          if (result[key]) {
            this.threeData[key] = result[key]
          }
        }

      }
    })

    this.salePrice = localStorage.getItem("salePrice");
    this.is_WeChat = false
    if (this.$route.query.row) {
      this.payUrl = JSON.parse(decodeURIComponent(this.$route.query.row))
      this.$nextTick(() => {
        document.forms[0].submit()
      })
    }

  },
  mounted() {
    // this.$nextTick(() => {
    //   history.pushState(null, null, document.URL)
    //   window.addEventListener('popstate', this.back, false)
    // })
  },

  destroyed() {
    // var timer = setInterval(() => {
    //   window.removeEventListener('popstate', this.back, false)
    //   clearInterval(timer)
    // }, 300)
  },
  methods: {
    //联系客服
    cust() {
      Dialog.confirm({
        title: '联系客服',
        message: '点击确定跳转人工客服',
      }).then(() => {
        window.location.href = this.kefuUrl
      }).catch(() => {
        // on cancel
      });
    },

    toBuyPrice(price) {
      this.price = price
      this.sureToRecharge(price);
    },
    cancelClose() {
      if (this.cancelSize >= 1) {
        this.isDialogShow = false;
      } else {
        this.cancelSize = 1;
        this.showPower = true
        history.pushState(null, null, document.URL)
      }

    },


    back() {
      if (localStorage.getItem('isWan') == 1) {
        this.showPower = true
        history.pushState(null, null, document.URL)
      }
    },
    cancelTitle() {
      this.showPower = false;
    },
    toTitle() {
      this.showPower = false;
      //this.sureToRecharge(this.price)
    },
    /**选择地址 */
    showAddressVisible() {
      this.addressVisible = true;
    },

    cancelSelectAddress() {
      this.addressVisible = false;
      this.addressTmp = "";
      this.userInfo.pcaAddress = "";
    },

    selectAddress(values) {
      if (!values[0].code || values[0].code.length < 1) {
        Toast.fail("请选择地区");
        return;
      }

      if (!values[1].code || values[1].code.length < 1) {
        Toast.fail("请选择地区");
        return;
      }


      this.ipAddr = values[0].name + '-' + values[1].name;
      this.addressVisible = false;
    },
    /***   修改密码     ***/
    passwordOnfocus() {
      this.passwordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    passwordOnDelete() {
      this.password = this.password.slice(0, this.password.length - 1);
    },

    passwordOnInput(key) {
      this.password = (this.password + key).slice(0, 6);
    },

    confirmPasswordOnfocus() {
      this.passwordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },

    cancelChangePassword() {
      this.password = "";
      this.confirmPassword = "";
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    checkPassword() {
      if (this.password.length < 6) {
        Dialog.alert({ message: "请设置六位支付密码" });
        return false;
      }

      if (this.password != this.confirmPassword) {
        Dialog.alert({ message: "两次输入的新密码不一致" });
        return false;
      }
      return true;
    },

    /***   修改密码  end   ***/
    sumbit() {
      this.showPasswordPanel = true;
    },
    //流量套餐充值时唤起微信支付
     onBridgeReady(param) {
      let _this = this;
      WeixinJSBridge.invoke("getBrandWCPayRequest", param, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          if(_this.$store.state.isNewPage==1||localStorage.getItem('isNewPage')==1){
             _this.$router
            .push({
              path: "/userNew/home",
              query: {
                iccid: _this.$store.state.iccid,
              },
            })
            .catch(() => {});
          }else{
            _this.$router
            .push({
              path: "/user/home",
              query: {
                iccid: _this.$store.state.iccid,
              },
            })
            .catch(() => {});
          }
         
        }
      });
    },

    async sureToRecharge(price) {
      price = this.price;
      var postUrl = "order/user/create/priceOrder";
      let postPayType = 20;

      await wxRequest( "sim/get/pay/state/price",  { iccid: localStorage.getItem("iccid")}, "post" ).then((res) => {
        if (res.data.code != 400) {
          //查询是什么支付类型
          if (res.data.code == 200) {
            postUrl = "order/lsPkgOrder/add/price";
            postPayType = 50;
          } else if (res.data.code == 502) {
            postUrl = "order/hfPkgOrder/add/price";
            postPayType = 60;
          }else if (res.data.code == 503) {
            postUrl = "order/jdPkgOrder/add/price";
            postPayType = 30;
          }else if (res.data.code == 508) {
            postUrl = "order/dhPkgOrder/add/price";
            postPayType = 80;
          }else if (res.data.code == 566) {
            postUrl = "order/ebPkgOrder/add/price";
            postPayType = 66;
          }else if (res.data.code == 588) {
            postUrl = "order/ali/user/create/priceOrder";
            postPayType = 88;
          }else if (res.data.code == 507) {
            postUrl = "order/yyPkgOrder/add/price";
            postPayType = 62;
          }
        }
      });

      var params = {
        iccid: this.$store.state.iccid ? this.$store.state.iccid : localStorage.getItem("iccid"),
        amount: price * 100, //固定值
        giftBalance: 0, //固定值
        yucun: 1, //固定值
        payType: postPayType, //
        huiyuan:'huiyuan'
      };
      await wxRequest(postUrl, params, "post").then((res) => {
        if (res.data.code == 200) {
          if (params.payType == 50) {
            //乐刷
            window.location.href = res.data.data.jspay_url;
          } else if (params.payType == 20) {
            //微信第三方
            var param = res.data.data.param;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 80||params.payType == 66) {
            //微信第三方
            var param = res.data.data;
            if (typeof WeixinJSBridge == "undefined") {
              if (document.addEventListener) {
                document.addEventListener(
                  "WeixinJSBridgeReady",
                  this.onBridgeReady,
                  false
                );
              } else if (document.attachEvent) {
                document.attachEvent("WeixinJSBridgeReady", this.onBridgeReady);
                document.attachEvent(
                  "onWeixinJSBridgeReady",
                  this.onBridgeReady
                );
              }
            } else {
              this.onBridgeReady(param);
            }
          } else if (params.payType == 60) {
            //汇付天下
            let datas = JSON.parse(res.data.data);
            if (datas.status === "succeeded") {
              let payment = datas;
              AdaPay.doPay(payment, (res) => {
                Dialog.alert({ title: "提示", message: res.result_message });
              });
            }
          }else if (params.payType == 30||params.payType == 62) {
              window.location.href=res.data.data;
          }else if(params.payType==88){
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                //进入引导页
                this.is_WeChat = true
                var timer = setInterval(()=>{
                  clearInterval(timer)
                  this.$router.push({path: '/user/simOpens', query: {row: encodeURIComponent(JSON.stringify(res.data.data))}});
                },1000)
            } else {
              this.payUrl = res.data.data
              this.$nextTick(()=>{
                document.forms[0].submit()
              })
            }
          }
        } else {
          Dialog.alert({ message: res.data.message });
        }
      });


    },
  },
};
</script>
<style lang="less" scoped>
.body {
  /* //background: url('../../assets/dzp/le20.jpg')no-repeat center; */
  background-repeat: no-repeat !important;
  background-position: center !important;
  background-size: 100% 100% !important;
  width: 100%;
  height: 100vh;
  position: relative;

  .footer-btn {
    position: fixed;
    bottom: 0px;
    left: 0px;
    right: 0px;
    margin: auto;

    .btn {
      width: 325px;
      height: 48px;
      background: linear-gradient(to right, rgb(255, 96, 52), rgb(238, 10, 36));
      /* background-size: 100% 100%; */
      margin: 10px auto;
      font-size: 18px;
      font-weight: 700;
      text-align: center;
      line-height: 48px;
      color: #fff;
      border-radius: 30px;
      animation: free_download 1s linear infinite alternate;
    }
  }

  .customer {
    position: fixed;
    right: 10px;
    top: 40%;
    width: 40px;
    height: 100px;
    text-align: center;
    color: #fff;
    font-size: 12px;

    img {
      width: 100%;
    }
  }

  .t-c {
   // border: 5px solid #50b9fd;
    border-radius: 10px;
    margin: 0 30px ;
    padding: 0 6px 70px;
    position: relative;

    .t-t {
      position: absolute;
      left: 50%;
      top: -20px;
      margin-left: -100px;
      width: 200px;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
    //  color: #fff;
      color: #FCF8EF;
      background-color: #50b9fd;
      border-radius: 10px;
      text-align: center;
      font-weight: bolder;
      letter-spacing: 2px;
    }

    .t-f {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      .t-v {
        width: 31%;
        height: 112px;
        background: url('~@/assets/dzp/1.png')no-repeat center;
        background-size: 100% 100%;
        font-size: 12px;
        font-weight: 700;
        padding: 20px 10px;
        box-sizing: border-box;
        position: relative;

        .mark {
          position: absolute;
          left: 0;
          top: 0;
          background-color: #d2d2d2;
          color: #fff;
          font-size: 12px;
          border-top-left-radius: 10px;
          border-bottom-right-radius: 10px;
          padding: 1px 8px;
        }

        .con2 {
          font-size: 35px;
          position: relative;
          text-align: center;
        }
      }

      .t-active {
        background: url('~@/assets/dzp/2.png')no-repeat center;
        background-size: 100% 100%;

        .mark {
          background-color: #50b9fd;
          color: #000;
        }
      }
    }

    .tips_box {
      background-color: #d1f0ff;
      padding: 6px 10px;
      border-radius: 15px;
      font-size: 12px;
      margin-top: 5px;
      width: calc(100% - 35px);
      margin-right: 15px;
      padding-top: 12px;

      h3 {
        font-size: 16px;
        margin-bottom: 5px;
        font-weight: bolder;
      }

      p {
        line-height: 20px;
      }
    }
  }

  .v-dialog {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;

    .v-dialog-bg {
      position: fixed;
      background: rgba(0, 0, 0, 0.7);
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;
    }

    .v-dialog-close {
      width: 22px;
      height: 22px;
      // margin:0 auto;
      // margin-top:20px;
      position: fixed;
      top: 0;
      bottom: -300px;
      left: 0;
      right: 0;
      margin: auto;

      img {
        height: 100%;
        cursor: pointer;
      }
    }

    .v-dialog-content {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      width: 100%;
      height: 100%;

      /* background: url("../../assets/user/3231.png") no-repeat center;
      background-size: 80% 50%; */
      .eixfr {
        position: relative;
        width: 90%;
        height: 360px;
        top: 20%;
        left: 5%;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .number {
        position: absolute;
        font-size: 18px;
        font-weight: 600;
        background: linear-gradient(to bottom, #D40017, #FF9115);
        /* 从左到右渐变 */
        -webkit-background-clip: text;
        /* Safari/Chrome */
        -webkit-text-fill-color: transparent;
        /* Safari/Chrome */
        color: transparent;
        /* Firefox/Opera */
        /* left: 24.5%; */
        top: 52%;
        font-family: DIN-Black;
        width: 97%;
        text-align: center;
      }

      .input {
        text-align: center;
        font-size: 10px;
        color: #7B3030;
        top: 64%;
        left: 39%;
        position: absolute;
      }

      .sumbit_btn {
        height: 46px;
        position: absolute;
        bottom: 14px;
        display: flex;
        left: -10px;
        margin: auto;
        right: 0;
        //  background: url("../../assets/user/321.png") no-repeat center;
        background-size: 100% 100%;
        animation: free_download 1s linear infinite alternate;
        width: 68%;
      }
    }
  }
}

@keyframes free_download {
  0% {
    transform: scale(.9);
  }

  100% {
    transform: scale(1);
  }
}

.i-a {
  display: flex;
  justify-content: space-between;
  margin: 0 30px;
  align-items: center;
}

.iphone {
  /* margin-bottom: 6px; */
  margin-left: 10px;
  font-size: 15px;
  font-weight: bold;

  span {
    color: #333;
  }

  .djsa {
    color: #c30d23;
  }
}

.addr {
  /* margin-left: 16px; */
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: bold;

  img {
    width: 12px;
    margin-right: 4px;
  }

  span {
    font-size: 10px;
    padding-right: 25px;
    color: #9fa0a0;
    font-weight: normal;
    // background: url('../../assets/user/2321.png')no-repeat center right;
  }
}

.changePasswordPanel-cardSetUp {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }
}

.shareit {
  -webkit-user-select: none;
  position: fixed;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  top: 0;
  left: 0;
  z-index: 999;
}

.shareit img {
  max-width: 100%;
}

.arrow {
  width: 100px;
  height: 150px;
  position: absolute;
  right: 5%;
  top: 1%;
}

.follow {
  margin-right: 6px;
  margin-left: 30px;
  width: 90%;
  // height: 100rpx;
  line-height: 30px;
  // text-align: left;
  text-decoration: none;
  font-size: 18px;
  color: white;
  float: left;
  margin-top: 180px;
}

.wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 38.2vh;
  left: 50%;
  margin-top: -50%;
  margin-left: -50%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .wrapper-img {
    width: 90%;
    height: 45%;
  }

  .close {
    width: 24px;
    position: relative;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
    font-size: .53333rem;
    font-weight: 700;
    line-height: 1;
    margin-top: 60px;
    color: #000;
    text-shadow: 0 0.02667rem 0 #fff;
  }
}
</style>